<script setup lang="ts">
import { useDisciplineCommentsStore } from '../model/comments/store'
import DisciplinePageLoader from './DisciplinePageLoader.vue'
import DisciplineComments from './DisciplineComments.vue'

defineOptions({
  name: 'DisciplineCommentsPage',
})

const store = useDisciplineCommentsStore()

/** The first page of comments shares the page loader; a further page shows its own loader under the list. */
const refIsFirstLoad = computed<boolean>(() => store.isLoading && !store.getComments.length)

onBeforeUnmount(() => {
  store.reset()
})
</script>

<template>
  <DisciplinePageLoader :loading="refIsFirstLoad" />
  <DisciplineComments />
</template>
